module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-ron-lach-7189449-small-1400e5fb309703dd169b2098d79906f2.jpg";